import RenderMediaAsset from "../RenderMediaAsset.tsx";
import React from "react";
import {AssetResponseItem, MediaAsset} from "../../@types/AssetTypes.ts";

export default function RenderAssetsAsCollage({assets}:{
    assets: AssetResponseItem[]
}){
    if (!assets || assets.length === 0) {
        return null;
    }
    const media = assets.map(({data})=>data as MediaAsset)
    if(media.length === 1){
        return <RenderMediaAsset
            sharpCorners
            hideLabel
            item={media[0]}
            width="100%"
            height="auto"
        />
    }
    if(media.length === 2 || media.length === 4){
        return <div className="grid grid-cols-2 gap-1">
            {media.map((data, index) => (
                <RenderMediaAsset
                    key={String(data.url)}
                    sharpCorners
                    hideLabel
                    item={data}
                    width="100%"
                    height={200}
                />
            ))}
        </div>
    }
    if(media.length === 3){
        return <div className="grid grid-cols-2">
                <div className="row-span-2">
                    <RenderMediaAsset
                        sharpCorners
                        hideLabel
                        item={media[0]}
                        width="100%"
                        height={400}
                    />
                </div>
                {media.slice(1).map((data, index) => (
                        <RenderMediaAsset
                            sharpCorners
                            hideLabel
                            item={data}
                            key={data.url}
                            width="100%"
                            height={200}
                        />
                ))}
        </div>
    }
    if(media.length > 4) {
        return <div className="grid grid-cols-2 gap-0 relative">
            {media.slice(0, 4).map((data, index) => (
                <div key={index} className="border border-base-200">
                    <RenderMediaAsset
                        sharpCorners
                        hideLabel
                        item={data}
                        key={data.url}
                        width="100%"
                        height={200}
                    />
                </div>
            ))}
            {media.length > 4 && (
                <div
                    className="absolute inset-0 flex items-center justify-center bg-black/50 rounded">
                    <span className="text-white text-2xl font-bold">
                        +{media.length - 4}
                    </span>
                </div>
            )}
        </div>

    }
}
